import { BenefitActivationDTOBenefitEnum, BenefitDTOBenefitEnum, TenantDTO, TenantDTOActiveBenefitsEnum } from 'probonio-shared-ui/api';
import { NonCashBenefit } from './nonCashBenefit/const';

export function isBenefitActive(tenant: TenantDTO | undefined, benefit: BenefitDTOBenefitEnum): boolean | undefined {
  const isActiveNonCash =
    benefit === BenefitActivationDTOBenefitEnum.Coupons &&
    Object.values(NonCashBenefit).some(nonCashBenefit => tenant?.activeBenefits?.includes(nonCashBenefit));

  return isActiveNonCash || tenant?.activeBenefits?.includes(benefit as TenantDTOActiveBenefitsEnum);
}
